import '../sass/media-gallery.scss';

(() => {
    const plyrScript = document.querySelector('#boomspace-theme-plyr-js');
    const $mediaGalleries = document.querySelectorAll('.media-gallery');

    if (!$mediaGalleries) return;
    
    $mediaGalleries.forEach($mediaGallery => {
        const $videos = $mediaGallery.querySelectorAll('.media-gallery__video');

        const initVideos = () => {
            if (!$videos) return;

            $videos.forEach($video => {
                const autoplay = $video.dataset?.autoplay === 'true';

                const player = new Plyr($video, {
                    controls: ['play-large', 'play', 'progress', 'mute', 'fullscreen'],
                    disableContextMenu: false,
                    autoplay: autoplay,
                    muted: autoplay,
                    loop: {
                        active: autoplay,
                    },
                });
            });
        };

        if (typeof Plyr !== 'undefined') {
            initVideos();
        } else {
            plyrScript.addEventListener('load', () => {
                initVideos();
            });
        }
    });
})();
